import { ExportColumnOptions } from '../types';
import resolveNonNegativeInteger from './resolveNonNegativeInteger';

const hasTextExportDecoration = (exportOptions: ExportColumnOptions): boolean =>
  exportOptions.prefix !== '' ||
  exportOptions.suffix !== '' ||
  resolveNonNegativeInteger(exportOptions.maxLength) !== undefined;

export default hasTextExportDecoration;
